export async function getFeatureStatus(axiosInstance) {
  try {
    const response = await axiosInstance.post('/v2/ai/get-all-features');
    if (response && response.data && response.data.status !== 'success') {
      // setSummaryStatus(response.data);
      // return response.data;
    }
    console.log(response, 'response from getFeatureStatus');
    
    return response.data.features;
    
  } catch (e) {
    console.error('Error parsing feature status from storage:', e);
    return null;
  }
}
 
// Update a feature's details by its ID (used for editing feature status)
export async function updateFeatureById(axiosInstance, data) {
  const payload = { data: [data], };
  return await axiosInstance.post(`/v2/client/update-ai-feature/${data.id}`, payload);
}
 
export async function updateFeatureByClient(axiosInstance, data) {
  const payload = { data: [data], };
  return await axiosInstance.post(`/v2/ai/updateFeatureById/${data.id}`, payload);
}
 
 
